// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"61a092d1","496":"d9d3b4da","498":"0ab7c6d3","703":"8d32af6a"}[chunkId] + ".chunk.js";
};